import {Record} from 'immutable';

import {roundToDecimals} from 'web-app/util/math';

/**
 * The types of sibling discounts allowed by the API
 */
export type SiblingDiscountApiType =
    | 'FIRST_SIBLING_OLDEST_FIRST'
    | 'SECOND_SIBLING_OLDEST_FIRST'
    | 'FIRST_SIBLING_YOUNGEST_FIRST'
    | 'SECOND_SIBLING_YOUNGEST_FIRST';

export interface IPreset {
    institutionId: string;
    discountPresetId: string;
    title: string;
    ordering: number;
    amount: number;
    type: SiblingDiscountApiType | null;
    accountId: string | null;
}

export class Preset extends Record<IPreset>({
    institutionId: '',
    discountPresetId: '',
    title: '',
    ordering: 1,
    amount: 0.2,
    type: null,
    accountId: null,
}) {}

const fromAPI = (data, institutionId): Preset => {
    return new Preset({
        discountPresetId: data.discountPresetId,
        title: data.title,
        ordering: data.ordering,
        amount: roundToDecimals(data.amount * 100, 2),
        institutionId,
        type: data.type ?? null,
        accountId: data.accountId ?? null,
    });
};

// I don't think this function is ever used.
const toAPI = data => {
    const preset = {
        title: data.title,
        ordering: data.ordering,
        amount: data.amount / 100,
        discountPresetId: null,
    };

    if (data.discountPresetId) {
        preset.discountPresetId = data.discountPresetId;
    }

    return preset;
};

export default {
    record: Preset,
    default: new Preset(),
    toAPI,
    fromAPI,
};
